import { relativeTime } from "@/lib/relativeTime";

/**
 * Compact `avatar | name | rep | "asked 3h ago"` chip used on question
 * rows and answer cards. Reputation slot ships as `—` in v1; the
 * structure is locked so we can add the number behind one line when
 * derivation lands.
 */
export function AuthorChip({
  displayName,
  ts,
  verb = "asked",
  reputation,
}: {
  displayName: string;
  ts: string | null;
  /** "asked" / "answered" / "edited" — drives the leading verb. */
  verb?: string;
  /** Optional reputation number. Omit (or `null`) renders `—`. */
  reputation?: number | null;
}) {
  const initial = (displayName || "?").slice(0, 1).toUpperCase();
  return (
    <div className="inline-flex items-center gap-2 text-xs-dense text-zinc-500 dark:text-zinc-400">
      <span className="text-[10px] text-zinc-400">{verb}{ts ? ` ${relativeTime(ts)}` : ""}</span>
      <span className="inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded bg-zinc-50 dark:bg-zinc-900 text-zinc-700 dark:text-zinc-200">
        <span
          className="inline-flex items-center justify-center w-4 h-4 rounded-sm bg-accent text-white text-[10px] font-semibold"
          aria-hidden="true"
        >
          {initial}
        </span>
        <span className="font-medium">{displayName}</span>
        <span className="text-zinc-400 dark:text-zinc-500 font-mono">
          {reputation == null ? "—" : reputation}
        </span>
      </span>
    </div>
  );
}
